import axios from "../../axiosInstance";
import type { HierarchyCreateRequest } from "@/modules/learningCenter/features/BadgeManagement/types/badge.types";

interface HierarchyResponse {
  success: boolean;
  hierarchyId: string;
}

export const createHierarchy = async (data: HierarchyCreateRequest): Promise<HierarchyResponse> => {
  const response = await axios.post<HierarchyResponse>("/api/badges/hierarchy", {
    parent_badge_id: data.parentBadgeId,
    child_badge_id: data.childBadgeId,
  });
  return response.data;
};

export default createHierarchy;
